function a(s) {
  var e = s.sheets;
  return '<?xml version="1.0" ?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' + e.map(function(o) {
    var t = o.id;
    return '<Relationship Id="rId'.concat(t, '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet').concat(t, '.xml"/>');
  }).join("") + '<Relationship Id="rId'.concat(e.length + 1, '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings" Target="sharedStrings.xml"/>') + '<Relationship Id="rId'.concat(e.length + 2, '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/>') + "</Relationships>";
}
export {
  a as default
};
//# sourceMappingURL=index.es210.js.map
